import { render } from "./tables_component.vue?vue&type=template&id=1a45364c&scoped=true"
import script from "./tables_component.vue?vue&type=script&lang=js"
export * from "./tables_component.vue?vue&type=script&lang=js"

import "./tables_component.vue?vue&type=style&index=0&id=1a45364c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a45364c"]])

export default __exports__